import { render, staticRenderFns } from "./roleDialog.vue?vue&type=template&id=57cce05b&"
import script from "./roleDialog.vue?vue&type=script&lang=js&"
export * from "./roleDialog.vue?vue&type=script&lang=js&"
import style0 from "./roleDialog.vue?vue&type=style&index=0&id=57cce05b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports